import { Box, SidebarModal } from '@domain-group/suit-theme'

import { toggleArray } from '@domain-group/javascript-utils'

import { useCampaignQuoteTemplateForm } from '@hooks/useCampaignQuoteTemplate'

import EntitySelector from '@components/EntitySelector'

import User from './User'

interface AssignedUsersProps {
  campaignQuoteTemplateFormPayload: ReturnType<typeof useCampaignQuoteTemplateForm>,
}

const AssignedUsers = (props: AssignedUsersProps) => {
  const {
    campaignQuoteTemplateFormPayload: {
      entityState: {
        user_ids,
      },
      setEntityState,
    },
  } = props

  return (
    <Box flexDirection="column">
      {/* @ts-expect-error */}
      <EntitySelector
        callbacks={{
          selectItem: (user) => {
            if (!user?.id) return
            setEntityState({ user_ids: toggleArray(user_ids, user.id) })
          },
        }}
        entityKey="users"
        entityTitleKey="full_name"
        label="Assign Users"
        marginTop="large"
        selectedIds={user_ids}
        showEntityId
        showSelectedEntity={false}
      />

      {!user_ids.length && (
        <SidebarModal.NoticeBox boxProps={{ marginTop: 'medium' }}>
          <SidebarModal.NoticeBox.Title>
            No Users Assigned
          </SidebarModal.NoticeBox.Title>

          <SidebarModal.NoticeBox.Paragraph>
            Quote Template will be visible for all users.
          </SidebarModal.NoticeBox.Paragraph>
        </SidebarModal.NoticeBox>
      )}

      {user_ids.map((userId: number) => (
        <User
          callbacks={{
            deleteUser: () => setEntityState({ user_ids: toggleArray(user_ids, userId) }),
          }}
          key={userId}
          userId={userId}
        />
      ))}
    </Box>
  )
}

export default AssignedUsers
